// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomNotificationCard_container__PBsjL","contact-card":"CustomNotificationCard_contact-card__t55fq"};